import { rem, tint } from 'polished'
import styled from 'styled-components'

interface IUploadContainerStyledProps {}

export const UploadContainerStyled = styled.div<IUploadContainerStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.small};

  width: 100%;
  padding: ${rem(6)} ${rem(12)};
  background-color: ${(props) => tint(0.3, props.theme.colors.offwhite)};
`
